module.exports = __webpack_public_path__ + "img/icp_logo.58f55c5c.png";